import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';

@Component({
  selector: 'app-remove-order-question-popup',
  templateUrl: './remove-order-question-popup.component.html',
  styleUrls: ['./remove-order-question-popup.component.css']
})
export class RemoveOrderQuestionPopupComponent implements OnInit {

  result: boolean;

  constructor(
    public dialogRef: MatDialogRef<RemoveOrderQuestionPopupComponent>,
    private ref: ElementRef,
    public shopSettingsService: ShopSettingsService,
    private renderer: Renderer2,
  ) {
  }

  ngOnInit() {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
    this.result = false;
  }

  okClick(): void {
    this.result = true;
    this.dialogRef.close();
  }

  cancelClick(): void {
    this.dialogRef.close();
  }
}
